import AccountingEntry from "./accounting-entries";

interface AccountingEntriesGroup {
  id?: number;
  taxPayerId?: number;
  relatedId?: string;
  relatedType?: string;
  status?: string;
  date?: string;
  obs?: string;
  items?: AccountingEntry[];
}

export const newAccountingEntryGroup = (): AccountingEntry => {
  return {};
};

export default AccountingEntriesGroup;
